import type { SiteSection } from '../routes.js'
import type { IconName } from '../ui/icons.js'

export const SITE_ITEMS: Record<SiteSection, { icon: IconName; labelKey: string }> = {
  contenuti: { icon: 'article', labelKey: 'nav.contents' },
  media: { icon: 'photo_library', labelKey: 'nav.media' },
  calendario: { icon: 'calendar_month', labelKey: 'nav.schedule' },
  piano: { icon: 'event', labelKey: 'editorialPlan.nav' },
  pagine: { icon: 'web', labelKey: 'nav.pages' },
  menu: { icon: 'menu_open', labelKey: 'nav.menus' },
  layout: { icon: 'dashboard', labelKey: 'siteLayouts.nav' },
  elenchi: { icon: 'view_list', labelKey: 'nav.listings' },
  redirect: { icon: 'alt_route', labelKey: 'nav.redirects' },
  tema: { icon: 'palette', labelKey: 'nav.theme' },
  sezioni: { icon: 'widgets', labelKey: 'nav.sections' },
  pubblicazioni: { icon: 'rocket_launch', labelKey: 'nav.publications' },
  impostazioni: { icon: 'settings', labelKey: 'nav.settings' },
}

/** The drawer by area: what is written, what shapes the site, when it goes out, how it is set up. */
export const SITE_GROUPS: { key: string; labelKey: string; sections: SiteSection[] }[] = [
  { key: 'content', labelKey: 'navGroup.content', sections: ['contenuti', 'media'] },
  { key: 'structure', labelKey: 'navGroup.structure', sections: ['pagine', 'menu', 'layout', 'elenchi', 'sezioni', 'tema'] },
  { key: 'planning', labelKey: 'navGroup.planning', sections: ['calendario', 'piano', 'pubblicazioni'] },
  { key: 'settings', labelKey: 'navGroup.settings', sections: ['redirect', 'impostazioni'] },
]

export interface JumpTarget {
  key: string
  label: string
  icon: IconName
  to: string
}

const fold = (text: string) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

/**
 * The screens whose name contains every word typed ("piano ed" finds the
 * editorial plan). Accents and case do not matter; an empty query matches
 * nothing, so the contents search keeps the panel to itself until it is asked.
 */
export function matchScreens(query: string, targets: JumpTarget[], limit = 5): JumpTarget[] {
  const words = fold(query).split(/\s+/).filter(Boolean)
  if (!words.length) return []
  return targets.filter((target) => words.every((word) => fold(target.label).includes(word))).slice(0, limit)
}
